var _rect, _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatinumParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBD5C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2854_9164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7023 36.5042C30.7175 36.5042 36.4045 30.8172 36.4045 23.8019C36.4045 16.7866 30.7175 11.0996 23.7023 11.0996C16.687 11.0996 11 16.7866 11 23.8019C11 30.8172 16.687 36.5042 23.7023 36.5042Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2854_9164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9045 23.8019C35.9045 30.541 30.4414 36.0042 23.7023 36.0042C16.9631 36.0042 11.5 30.541 11.5 23.8019C11.5 17.0628 16.9631 11.5996 23.7023 11.5996C30.4414 11.5996 35.9045 17.0628 35.9045 23.8019Z",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0582 11.2534L24.0601 36.4099",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2078 23.6503C36.2078 23.6503 18.895 24.0892 11.0513 24.001",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1299 12.3228C29.1299 12.3228 36.3065 24.6316 29.1299 35.2809",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2679 35.2796C12.9047 19.9941 18.4818 12.2188 18.4818 12.2188",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8103 19.9699C35.8103 19.9699 24.0062 11.6375 11.5947 19.9699",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5329 28.4288C35.5329 28.4288 26.62 34.8623 11.822 28.3091",
    stroke: "#B0654D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6062 19.7155L16.206 17.7031L15.9185 23.7403H11.0312L11.6062 19.7155Z",
    fill: "#B0654D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.781 30.3527L12.1812 28.3403C13.0437 31.5027 14.7686 33.8026 17.9309 34.9525L16.781 30.3527Z",
    fill: "#B0654D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2058 24.3153L24.2554 24.0278V31.215L16.7808 30.065L16.2058 24.3153Z",
    fill: "#B0654D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0321 11.0726C34.4053 10.9482 34.6982 10.6553 34.8226 10.2821L35.3577 8.67691C35.4033 8.54015 35.5967 8.54015 35.6423 8.67691L36.1774 10.2821C36.3018 10.6553 36.5947 10.9482 36.9679 11.0726L38.5731 11.6077C38.7098 11.6533 38.7098 11.8467 38.5731 11.8923L36.9679 12.4274C36.5947 12.5518 36.3018 12.8447 36.1774 13.2179L35.6423 14.8231C35.5967 14.9598 35.4033 14.9598 35.3577 14.8231L34.8226 13.2179C34.6982 12.8447 34.4053 12.5518 34.0321 12.4274L32.4269 11.8923C32.2902 11.8467 32.2902 11.6533 32.4269 11.6077L34.0321 11.0726Z",
    fill: "#B0654D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5321 15.5726C37.9053 15.4482 38.1982 15.1553 38.3226 14.7821L38.3577 14.6769C38.4033 14.5402 38.5967 14.5402 38.6423 14.6769L38.6774 14.7821C38.8018 15.1553 39.0947 15.4482 39.4679 15.5726L39.5731 15.6077C39.7098 15.6533 39.7098 15.8467 39.5731 15.8923L39.4679 15.9274C39.0947 16.0518 38.8018 16.3447 38.6774 16.7179L38.6423 16.8231C38.5967 16.9598 38.4033 16.9598 38.3577 16.8231L38.3226 16.7179C38.1982 16.3447 37.9053 16.0518 37.5321 15.9274L37.4269 15.8923C37.2902 15.8467 37.2902 15.6533 37.4269 15.6077L37.5321 15.5726Z",
    fill: "#B0654D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumParty);
export default __webpack_public_path__ + "static/media/platinum-party.62322ceaf66e90e5302b78da6b4788a5.svg";
export { ForwardRef as ReactComponent };